import type { CSSProperties, PropsWithChildren } from 'react';

import { REPORT_PAGE_HEIGHT } from '../PageConfigProvider/constants';
import styles from './ContentGrid.module.css';

const reportPageStyle = {
  '--report-page-height': `${REPORT_PAGE_HEIGHT}px`,
} as CSSProperties;

export const ReportWrapper = ({
  isReport = false,
  children,
}: { isReport?: boolean } & PropsWithChildren) => {
  if (!isReport) return children;
  return (
    <div className={styles.reportPage} style={reportPageStyle}>
      {children}
    </div>
  );
};
